var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.908 7.5 1-3c.109-.317.05-.667-.141-.942a1.046 1.046 0 0 0-.842-.433H5.292v-.208a.63.63 0 0 0-.625-.625.63.63 0 0 0-.625.625v14.166a.63.63 0 0 0 .625.625.63.63 0 0 0 .625-.625v-5.208h9.633c.333 0 .65-.158.842-.433.191-.275.25-.625.141-.942l-1-3Zm-1.25.2.975 2.925H5.292v-6.25h9.341L13.658 7.3a.629.629 0 0 0 0 .392V7.7Z",
    fill: "current"
  })));
};
export default SvgFlag;